import classNames from 'classnames';
import { Link } from 'react-router-dom';

import { isExternalUrl } from '@/public/utils/url';

import styles from './tabs.module.scss';

interface TabsProps {
  items: {
    id?: string;
    label: string;
    href?: string;
    onClick?(): void;
  }[];
  activeIndex?: number;
}

export const Tabs = (props: TabsProps) => {
  const { items, activeIndex } = props;

  return (
    <ol className={styles.container}>
      {items.map(({ id, label, href, onClick }, idx) => (
        <li key={id ?? idx}>
          {href !== undefined && !isExternalUrl(href) ? (
            <Link
              data-router-link
              to={href}
              className={classNames(styles.tab, idx === activeIndex && styles.activeTab)}
              onClick={onClick}>
              {label}
            </Link>
          ) : href !== undefined ? (
            <a
              href={href}
              className={classNames(styles.tab, idx === activeIndex && styles.activeTab)}
              onClick={onClick}>
              {label}
            </a>
          ) : (
            <button
              className={classNames(styles.tab, idx === activeIndex && styles.activeTab)}
              onClick={onClick}>
              {label}
            </button>
          )}
        </li>
      ))}
    </ol>
  );
};
